export default {"src":"/_next/static/media/logo Safir Uni en.a9302e90.svg","height":52,"width":167,"blurWidth":0,"blurHeight":0};